import { Component, OnInit, AfterViewInit, HostListener } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";

//Models
import { User } from "app/core/models/user";
import { CustomError } from "app/core/models/custom-error";

//Services
import { AuthService } from "app/core/services/auth.service";
import { NavBarService } from "app/core/services/nav-bar.service";
import { UserService } from "app/core/services/user.service";
import { CurrentUserService } from "app/core/services/current-user.service";
import { UtilService } from "app/core/services/util.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  defaultLogin: string;
  serviceEnabled: boolean;
  loginInfo: any = {};
  currentUser: User;

  loggedOut: boolean;
  loginFailed: boolean;

  loggingIn: { inProgress: boolean; message: string };
  loginError: CustomError;
  showResendLink: boolean = false;
  resendEmail: string;

  resending: any = {
    status: null
  };


  token: string;
  callback: string = environment.APP_ROOT; //environment


  //click anywhere on the page should submit the form
  @HostListener("document:keydown.enter", ["$event"])
  documentClick(event: MouseEvent) {
    this.submitLogin();
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    // private courseService: CourseService,
    private navBarService: NavBarService,
    private authService: AuthService,
    private currentUserService: CurrentUserService,
    private utilService: UtilService
  ) { }

  ngOnInit() {
    this.defaultLogin = "service";
    this.serviceEnabled = false;
    this.loginInfo = { username: "", password: "" };

    this.loginFailed = false;
    this.loggedOut = false;
    this.loggingIn = { inProgress: false, message: "Processing login..." };

    this.authService.logout();

    this.loggedOut = this.activatedRoute.snapshot.queryParams["loggedout"];
  }


  async submitLogin() {
    // this.router.navigate(["/login"]);

    this.loggedOut = false;
    this.loginFailed = false;
    this.loggingIn.inProgress = true;

    try {


      await this.authService.getAccessToken(
        this.loginInfo.username,
        this.loginInfo.password
      );
      //TODO: auth service should fail, if not active


      const currentUser = await this.userService.getUser();

      // console.log(currentUser);

      // if (!currentUser.verified) {
      //   this.showResendLink = true;
      //   throw new CustomError("Your email address has not been verified", "Please click on the link in the confirmation email sent to you. To resend the confirmation email, click the link below.");
      // }
      // else {


      this.currentUserService.setCurrentUser(currentUser);

      this.router.navigate(["/user"]).then(() => {
        this.loggingIn.inProgress = false;
        this.loginFailed = false;
        // console.log("Logged in!");
      });
      // }


    } catch (error) {
      console.log(error);

      this.loggingIn.inProgress = false;
      this.loginFailed = true;

      //check status code

      if (error.status == 401) {

        this.loginError = new CustomError(
          "401",
          "Login failed",
          "Please check your email/password and try again.",
          null
        );

      }
      else if (error.status == 403) {

        this.showResendLink = true;
        this.resendEmail = this.loginInfo.username;

        //account has not been activated yet
        this.loginError = new CustomError(
          "403",
          "Your email address has not been verified", "Please click on the link in the confirmation email sent to you. To resend the confirmation email, click the link below.",
          null
        );
      }
      else {
        this.loginError = this.utilService.handleApiError(error)
      }


    }

  }

  async resendConfirmation() {

    //make sure username (email) is filled
    this.resending.status = "sending";

    try {
      await this.authService.resendConfirmation(this.resendEmail, this.callback);
      this.resending.status = "sent";
    }
    catch (error) {

    }
    finally {

    }

  }
}
